import {loadable} from "jotai/utils";
import {atomWithRefresh} from "../utils/jotaiUtils";
import {routerFarmIdAtom} from "./routerStore";
import {activeCompanyFarmsAtom} from "./activeCompanyFarmsStore";
import {Farm} from "../types/domain/farm";
import {InsightOverviewData} from "../types/domain/insightOverviewData";
import {activeCompanyIdAtom} from "./activeCompanyStore";
import {activeDateAtom} from "./activeDateStore";
import {showActiveFieldsAtom} from "./filterSelectionStore";
import {getInsightOverview} from "../services/insightOverviewService";
import dayjs from "dayjs";
import {activeMergedFarmIds} from "./activeMergedFarmIds";

export const activeFarmAtom = atomWithRefresh<Promise<Farm | undefined>>(async (get) => {
    const activeFarmId = get(routerFarmIdAtom);
    const farms = await get(activeCompanyFarmsAtom);

    return activeFarmId ? farms.mapByFarmId[activeFarmId] : undefined;
});

export const activeFarmLoadable = loadable(activeFarmAtom);

/*
 * Get overview data for a farm (or merged farms) and active date
 */
export const activeFarmOverviewData = atomWithRefresh<Promise<InsightOverviewData>>(async (get) => {
    const activeCompanyId = await get(activeCompanyIdAtom);
    const activeDate = (await get(activeDateAtom)) ?? dayjs();
    const onlyActiveOrders = get(showActiveFieldsAtom);
    const farmIds = get(activeMergedFarmIds);

    return await getInsightOverview(activeCompanyId, activeDate, onlyActiveOrders, farmIds);
});

export const activeFarmOverviewDataLoadable = loadable(activeFarmOverviewData);
